import classname from 'classnames';
import MMModal from '../modal/modal';
import styles from './index.module.less';
import * as React from 'react';
import { autobind } from 'core-decorators';
import modal from './index';
import { guid } from '../utils';

interface IMMToastProps {
    mask?: boolean;
    duration?: number;
}

enum ToastState {
    new,
    showing,
    hideing
}

interface IMMToastState {
    visible: boolean;
    messages: {
        id: string;
        message: string;
        iconfont?: string;
        animation?: boolean
        state: ToastState
    }[];
}

@autobind
export default class MMToast extends React.Component<IMMToastProps, IMMToastState> {
    static options = {
        addGlobalClass: true
    };

    static defaultProps = {
        mask: false,
        duration: 2000
    };

    state: IMMToastState = {
        visible: true,
        messages: []
    };

    clearSetTimeout: any;

    componentDidMount() {
        (modal as any)['toast'] = this.message;
    }

    /**
     * 动画
     *
     * @param {string} msg
     * @memberof MMToast
     */
    message(msg: string, animation?: boolean) {
        const id = guid();
        this.setState({
            messages: [...this.state.messages, {
                id,
                message: msg,
                animation,
                state: ToastState.new
            }]
        });

        setTimeout(() => this.setState({
            messages: this.state.messages.map(value => {
                if (value.id === id) {
                    return { ...value, state: ToastState.showing };
                }
                return value;
            })
        }), 100);

        setTimeout(() => this.setState({
            messages: this.state.messages.map(value => {
                if (value.id === id) {
                    return { ...value, state: ToastState.hideing };
                }
                return value;
            })
        }), this.props.duration);

        // 变量需要和less的 @transitionTiming 一样
        clearTimeout(this.clearSetTimeout);
        const transitionTiming = 500;
        this.clearSetTimeout = setTimeout(() => this.clear(), (this.props.duration as number) + transitionTiming);
    }

    clear() {
        this.setState({
            messages: []
        });
    }

    render() {
        return <MMModal visible={this.state.visible} mask={this.props.mask}>
            <div className={styles.MMToast}>
                {this.state.messages.map(value => <div key={value.id} className={this.getMessageClassName(value)}>
                    {value.message}
                </div>)}
            </div>
        </MMModal>;
    }

    getMessageClassName(value: { id: string; message: string; state: ToastState }): string | undefined {
        const classArray = [styles.MMToast_message];
        switch (value.state) {
            case ToastState.showing:
                classArray.push(styles.MMToast_message__showing);
                break;
            case ToastState.hideing:
                classArray.push(styles.MMToast_message__hideing);
                break;
        }

        return classname(...classArray);
    }
}

